import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import CheckBenefit from "@/pages/CheckBenefit";
import FindVendor from "@/pages/FindVendor";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AboutUs from "@/pages/AboutUs";
import HelpCentre from "@/pages/HelpCentre";
import ProgrammeMarketplace from "@/pages/ProgrammeMarketplace";
import DevelopmentPartners from "@/pages/DevelopmentPartners";
import Complaints from "@/pages/Complaints";
import Impact from "@/pages/Impact";
import PaymentCallback from "@/pages/PaymentCallback";
import ImpactCard from "@/pages/ImpactCard";
import BeneficiaryPortal from "@/pages/BeneficiaryPortal";
import SponsorDashboard from "@/pages/SponsorDashboard";
import VendorPortal from "@/pages/VendorPortal";
import AdminDashboard from "@/pages/AdminDashboard";
import ComplaintsAdmin from "@/pages/ComplaintsAdmin";
import SmsAdmin from "@/pages/SmsAdmin";
import AdminPayouts from "@/pages/AdminPayouts";
import SponsorshipThankYou from "@/pages/SponsorshipThankYou";
import SponsorshipManage from "@/pages/SponsorshipManage";
import AdminInvoices from "@/pages/AdminInvoices";
import CoordinatorPortal from "@/pages/CoordinatorPortal";
import FinancePortal from "@/pages/FinancePortal";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/register" element={<Register />} />
            <Route path="/check" element={<CheckBenefit />} />
            <Route path="/find-vendor" element={<FindVendor />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/help" element={<HelpCentre />} />
            <Route path="/programmes" element={<ProgrammeMarketplace />} />
            <Route path="/partners" element={<DevelopmentPartners />} />
            <Route path="/report" element={<Complaints />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/payment/callback" element={<PaymentCallback />} />
            <Route path="/sponsorship/thank-you" element={<SponsorshipThankYou />} />
            <Route path="/sponsorship/manage" element={<SponsorshipManage />} />
            <Route path="/sponsorship/manage/:token" element={<SponsorshipManage />} />
            <Route path="/sponsor/impact-card" element={<ProtectedRoute roles={["sponsor"]}><ImpactCard /></ProtectedRoute>} />
            <Route path="/beneficiary" element={<ProtectedRoute roles={["beneficiary"]}><BeneficiaryPortal /></ProtectedRoute>} />
            <Route path="/sponsor" element={<ProtectedRoute roles={["sponsor"]}><SponsorDashboard /></ProtectedRoute>} />
            <Route path="/vendor" element={<ProtectedRoute roles={["vendor"]}><VendorPortal /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin", "super_admin"]}><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/complaints" element={<ProtectedRoute roles={["admin", "super_admin"]}><ComplaintsAdmin /></ProtectedRoute>} />
            <Route path="/admin/sms" element={<ProtectedRoute roles={["admin", "super_admin"]}><SmsAdmin /></ProtectedRoute>} />
            <Route path="/admin/payouts" element={<ProtectedRoute roles={["admin", "super_admin", "finance"]}><AdminPayouts /></ProtectedRoute>} />
            <Route path="/admin/invoices" element={<ProtectedRoute roles={["admin", "super_admin", "finance"]}><AdminInvoices /></ProtectedRoute>} />
            <Route path="/coordinator" element={<ProtectedRoute roles={["state_coordinator"]}><CoordinatorPortal /></ProtectedRoute>} />
            <Route path="/finance" element={<ProtectedRoute roles={["finance"]}><FinancePortal /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
